import {assert} from 'assert-ts';
import type {Schemas} from 'domainTypes/dto';
import type {
  VerifiedLinkedCatalogPost,
  VerifiedLinkedLiterary,
} from 'schemaDefinition/types';
import {
  mapBaseRelationDto,
  mapWorkToAgentRelationDto,
  mapWorkToSeriesRelationDto,
} from 'services/agent/mappers/mapRelationsDto';
import {sortLinks} from 'services/agent/mappers/sortLinks';
import type {WorkRelationsDto} from '../types';
import {sortByOptionalOrder} from './sortByOrder';

export const mapWorkRelationsDto = (
  dto: WorkRelationsDto,
): VerifiedLinkedLiterary[] | undefined => {
  const {workRelations = [], agentRelations = [], seriesRelations = []} = dto;

  const links =
    workRelations.length > 0 ||
    agentRelations.length > 0 ||
    seriesRelations.length > 0
      ? [
          ...seriesRelations
            .sort(sortByOptionalOrder)
            .map(relDto => mapWorkToSeriesRelationDto(relDto)),
          ...workRelations
            .sort(sortByOptionalOrder)
            .map(relDto => mapWorkToWorkRelationDto(relDto)),
          ...agentRelations
            .sort(sortByOptionalOrder)
            .map(relDto => mapWorkToAgentRelationDto(relDto, 'generalAgent')),
        ]
      : undefined;

  const anyOrdered =
    seriesRelations.some(rel => !Number.isNaN(rel.order)) ||
    workRelations.some(rel => !Number.isNaN(rel.order)) ||
    agentRelations.some(rel => !Number.isNaN(rel.order));

  // Fallback to old sorting if none are sorted.
  return anyOrdered ? links : sortLinks(links);
};

/** Maps work to work relation */
const mapWorkToWorkRelationDto = ({
  title,
  ...dto
}: Schemas.WorkToWorkRelationDto): VerifiedLinkedCatalogPost => {
  const {role, link} = mapBaseRelationDto(dto) as VerifiedLinkedCatalogPost;

  assert.soft(title, 'mapWorkRelationDto: title expected');

  return {
    role,
    link: {
      ...link,
      name: title ?? ' - ',
    },
  };
};
